import { servicesSelectors } from '~/selectors';
import { updateAppointmentsDetailsInWindowDataLayer } from '~/analytics/analytics.utils';
import { RESTORE_ANALYTICS } from '~/api/analytics/analytics.actions';

export const restoreAnalyticsDataLayer = (store) => (next) => (action) => {
  next(action);

  if (action.type === RESTORE_ANALYTICS) {
    const state = store.getState();
    const { getAnalyticsData } = servicesSelectors.selectServicesConfig(state);

    if (getAnalyticsData) {
      const journeyDetails = getAnalyticsData(action.payload);
      updateAppointmentsDetailsInWindowDataLayer({ ...journeyDetails });
    }
  }
};
